<template>
    <div id="app">
        <TopNav></TopNav>
        <general-notifications></general-notifications>
        <el-tabs v-model="activeName" type="border-card" id="selection-tabs" v-if="authenticated" style="margin: 10px">
            <el-tab-pane label="Singles Preliminary" name="preliminary">
                <preliminary></preliminary>
            </el-tab-pane>
            <el-tab-pane label="Singles Acceptance" name="acceptance">
                <acceptance></acceptance>
            </el-tab-pane>
            <el-tab-pane label="Doubles Preliminary" name="doubles-preliminary">
                <doubles-preliminary></doubles-preliminary>
            </el-tab-pane>
            <el-tab-pane label="Doubles Acceptance" name="doubles-acceptance">
                <doubles-acceptance></doubles-acceptance>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<style>
.el-tabs__item {
    font-size: 16px;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item {
    color: black;
}

.el-table {
    font-size: 0.9em;
    margin-top: 40px;
    border: 1px solid black;
}

.el-table td,
.el-table th {
    border: 0.5px solid black;
}

.el-table__header th {
    font-size: 16px;
    color: black;
}

.el-table .cell {
    white-space: normal;
    word-break: normal;
    line-height: 23px;
    padding-left: 7px;
}

.el-card {
    margin-top: 5px;
    border-radius: 4px;
    border: 1px solid black;
    background-color: #ffffff;
    overflow: hidden;
    color: #303133;
    transition: 0.3s;
}

h3 {
    font-size: 1em;
}
</style>

<script>
import Preliminary from "./components/Preliminary.vue";
import Acceptance from "./components/Acceptance.vue";
import DoublesPreliminary from "./components/DoublesPreliminary.vue";
import DoublesAcceptance from "./components/DoublesAcceptance.vue";
import DrawSizeHeader from "./widgets/DrawSizeHeader.vue";
import DebugHeaderWithSelection from "./widgets/DebugHeaderWithSelection.vue";
import GeneralNotifications from "./widgets/GeneralNotifications.vue";
import TopNav from "~/components/TopNav";

import moment from "moment";
import {Loading} from "element-ui";
import {mapGetters, mapActions} from "vuex";
import LogRocket from "logrocket";

export default {
    components: {
        Preliminary,
        Acceptance,
        DoublesPreliminary,
        DoublesAcceptance,
        DrawSizeHeader,
        DebugHeaderWithSelection,
        GeneralNotifications,
        TopNav
    },
    data() {
        return {
            activeName: "preliminary",
            isProduction: IS_PRODUCTION,
            authenticated: false
        };
    },
    computed: {
        ...mapGetters("singlesEntrySystem", ["playerIdentifier"]),
    },
    created: function () {
        let loader = Loading.service({
            target: "#selection-tabs",
            text: "Loading... might take up to one minute on busy days",
            fullscreen: false,
        });
        this.authenticateAgainstAd().then(() => {
            let that = this;
            this.fetchEverythingForPrelimAndAcceptance()
                .then(() => {
                    loader.close();
                })
                .catch((error) => {
                    loader.close();
                    that.$notify({
                        title: "Error",
                        message: "Error while retrieving data from server!",
                    });
                });
            window.setInterval(() => {
                this.updateDateValue(moment());
            }, 1000 * 40);
            window.setTimeout(() => {
                location.reload();
            }, 1000 * 60 * 10);
        })
    },
    methods: {
        ...mapActions("singlesEntrySystem", [
            "fetchEverythingForPrelimAndAcceptance",
            "updateDateValue",
        ]),
        async authenticateAgainstAd() {
            const data = await this.$msal.authenticateRedirect();
            const token = await this.$msal.getSilentToken(data[0], ['User.Read']);
            const graphResponse = await this.$msal.callMSGraph('https://graph.microsoft.com/v1.0/me?$select=displayName,givenName,employeeId', token.accessToken);
            const jsonResponse = await graphResponse.json();
            localStorage.setItem('jwt', token.idToken);
            localStorage.setItem('accessToken', token.accessToken);
            LogRocket.identify(jsonResponse.employeeId, {
                name: jsonResponse.displayName,
                email: token.idTokenClaims.preferred_username,
                roleType: token.idTokenClaims.roles,
                overwrittenType: localStorage.getItem('overwrittenPlayerIdentifier') !== null,
            });
            if (localStorage.getItem('overwrittenPlayerIdentifier') === null) {
                this.$store.commit('singlesEntrySystem/updatePlayerValue', jsonResponse.employeeId);
            } else {
                this.$store.commit('singlesEntrySystem/updatePlayerValue', localStorage.getItem('overwrittenPlayerIdentifier'));
            }
            console.log('Authentication was successful');
            this.authenticated = true
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/AppAllAcceptanceLists.vue